import { getLocalAccessToken } from "../utils/helper";
import { Toast } from "../components/notify/Notify";
import { url } from "../constants/path";
import api from "../services/api";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.sharedResource;

export const getSideBar = (callback) => {
  api
    .get(`${URL}/sidebar`)
    .then((response) => callback(response.data.data.list))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getACDetailByRouteName = (routeName, callback) => {
  api
    .get(`${URL}/sidebar/by-route?route=${routeName}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
